import React, { useEffect, useState } from 'react';
function getRemaining() {
  const now = new Date();
  const endOfDay = new Date(now);
  endOfDay.setHours(23, 59, 59, 999);
  const diff = Math.max(0, endOfDay.getTime() - now.getTime());
  return {
    hours: Math.floor(diff / 3_600_000),
    minutes: Math.floor(diff % 3_600_000 / 60_000),
    seconds: Math.floor(diff % 60_000 / 1000)
  };
}
const pad = (value: number) => String(value).padStart(2, '0');
export function Countdown() {
  const [time, setTime] = useState(getRemaining);
  useEffect(() => {
    const id = window.setInterval(() => setTime(getRemaining()), 1000);
    return () => window.clearInterval(id);
  }, []);
  const units = [{
    value: time.hours,
    label: 'Horas'
  }, {
    value: time.minutes,
    label: 'Minutos'
  }, {
    value: time.seconds,
    label: 'Segundos'
  }];
  return <div className="flex items-center justify-center gap-3" role="timer" aria-live="off" data-id="element-62" data-mp="10cv0k43407ek">
      {units.map(unit => <div key={unit.label} className="min-w-[68px] rounded-xl bg-plum px-3 py-2 text-center text-cream" data-id="element-63" data-mp="159bz7s7xq45w">
          <span className="block font-display text-2xl font-black leading-none tabular-nums sm:text-3xl" data-id="element-64" data-mp="t2ljj7b2zg0o">
            {pad(unit.value)}
          </span>
          <span className="mt-1 block font-sans text-[10px] uppercase tracking-widest text-cream/60" data-id="element-65" data-mp="17q6jwtgkn14w">
            {unit.label}
          </span>
        </div>)}
    </div>;
}